
import BenchmarkFilter from "@/pages/benchmark/pages/genre/components/BenchmarkFilter";
import GenreTableService from "@/pages/benchmark/pages/genre/components/GenreTableService";
import MetricTable from "@/pages/benchmark/pages/genre/components/MetricTable";
import MetricTableService from "@/pages/benchmark/pages/genre/components/MetricTableService";

export default {
  BenchmarkFilter,
  MetricTableService,
  MetricTable,
  GenreTableService
};